const paymentAcademicMonths = [
    { value: 1,  title: 'Сентябрь', order: 1 },
    { value: 2,  title: 'Октябрь',  order: 2 },
    { value: 3,  title: 'Ноябрь',   order: 3 },
    { value: 4,  title: 'Декабрь',  order: 4 },
    { value: 5,  title: 'Январь',   order: 5 },
    { value: 6,  title: 'Февраль',  order: 6 },
    { value: 7,  title: 'Март',     order: 7 },
    { value: 8,  title: 'Апрель',   order: 8 },
    { value: 9,  title: 'Май',      order: 9 },
    { value: 10, title: 'Июнь',     order: 10 },
    { value: 11, title: 'Июль',     order: 11 },
    { value: 12, title: 'Август',   order: 12 },
];

const getPaymentEndMonthOptions = (monthFrom, months = paymentAcademicMonths) => {
    const fromMonth = months.find((month) => month.value === Number(monthFrom));

    if (!fromMonth) {
        return [];
    }

    return months.filter((month) => month.order > fromMonth.order);
};

const getPaymentAcademicYear = (response) => {
    const yearId = response?.data?.yearId ?? response?.data?.payment_context?.year?.id;

    return Number.isInteger(yearId) ? yearId : null;
};

const invalidatePaymentAmount = (state) => ({
    ...state,
    paymentSum: null,
    paymentSumRequestVersion: Number(state.paymentSumRequestVersion || 0) + 1,
});

const isPaymentAmountRequestCurrent = (state, requestVersion) =>
    state.paymentSumRequestVersion === requestVersion;

module.exports = {
    paymentAcademicMonths,
    getPaymentEndMonthOptions,
    getPaymentAcademicYear,
    invalidatePaymentAmount,
    isPaymentAmountRequestCurrent,
};
